import { styled } from '@zenbusiness/zui/styles';
import Text from '@zenbusiness/zui/Text';

export const NumberStepStyled = styled(Text)(({ theme }) => ({
  backgroundColor: theme.palette.fixed.black,
  width: '24px',
  height: '24px',
  borderRadius: '50%',
  color: theme.palette.text.white,
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
}));
